import React from 'react';
import { Modal, ModalBody, Row, Col, Button } from 'reactstrap';
import { Icon } from '../../../../components/Component';
import { activeStatus } from '../../../../utils/envConfig';

const LeadDetailsModal = ({ isOpen, leadData, toggle }) => {
    if (!leadData) {
        return null; // Or a loading/empty state
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered" size="lg">
            <ModalBody>
                <a
                    href="#cancel"
                    className="close"
                    onClick={(ev) => {
                        ev.preventDefault();
                        toggle();
                    }}
                >
                    <Icon name="cross-sm" />
                </a>
                <div className="nk-tnx-details mt-sm-3">
                    <div className="nk-modal-head mb-3">
                        <h5 className="title">User Details</h5>
                    </div>
                    <Row className="gy-3 mb-3">
                        <Col lg={6}>
                            <span className="sub-text">First Name</span>
                            <span className="caption-text">{leadData?.first_name}</span>
                        </Col>
                        <Col lg={6}>
                            <span className="sub-text">Last Name</span>
                            <span className="caption-text">{leadData?.last_name}</span>
                        </Col>
                        <Col lg={6}>
                            <span className="sub-text">Email</span>
                            <span className="caption-text">{leadData?.email}</span>
                        </Col>
                        <Col lg={6}>
                            <span className="sub-text">Status</span>
                            <span className="caption-text">
                                {leadData?.active ? activeStatus[0] : activeStatus[1]}
                            </span>
                        </Col>
                    </Row>
                    <div className="nk-modal-head mb-3">
                        <h5 className="title">Preferences</h5>
                    </div>
                    <Row className="gy-3">
                        <Col lg={6}>
                            <span className="sub-text">Unit Number</span>
                            <span className="caption-text">
                                {leadData?.preference?.plotNumber ? leadData?.preference?.plotNumber : '-'}
                            </span>
                        </Col>
                        <Col lg={6}>
                            <span className="sub-text">Rooms</span>
                            <span className="caption-text">
                                {leadData?.preference?.rooms ? leadData?.preference?.rooms : '-'}
                            </span>
                        </Col>
                        <Col lg={6}>
                            <span className="sub-text">Type of property</span>
                            <span className="caption-text">
                                {leadData?.preference?.typeOfProperty ? leadData?.preference?.typeOfProperty : '-'}
                            </span>
                        </Col>
                        <Col lg={6}>
                            <span className="sub-text">Building/Area</span>
                            <span className="caption-text">
                                {leadData?.preference?.area ? leadData?.preference?.area : '-'}
                            </span>
                        </Col>
                        <Col lg={6}>
                            <span className="sub-text">Location</span>
                            <span className="caption-text">
                                {leadData?.preference?.location ? leadData?.preference?.location : '-'}
                            </span>
                        </Col>
                    </Row>
                    <div className="col-md-6 justify-content-start d-flex">
                        <Button
                            outline
                            color="secondary"
                            className="mt-3"
                            onClick={() => (window.location.href = `/user-profile/${leadData?.id}/user-profile`)}
                        >
                            More Details
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default LeadDetailsModal;